<template>
  <div class="manage-content customization-settings page-card-wrapper">
    <div class="page-card-title">
      <span class="page-card-title-text">{{
        $t('text.customization_settings')
      }}</span>
    </div>
    <div class="pt-30 page-card-content">
      <el-tabs type="border-card">
        <el-tab-pane>
          <span slot="label"
            ><i class="el-icon-edit"></i> {{ $t('text.colors') }}</span
          >
          <Colors ref="colors" />
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"
            ><i class="el-icon-s-tools"></i> {{ $t('text.font') }}</span
          >
          <Font ref="font" />
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"
            ><i class="el-icon-picture"></i> {{ $t('text.logo') }}</span
          >
          <Logo ref="logo" />
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"
            ><i class="el-icon-picture"></i>
            {{ $t('text.login_background') }}</span
          >
          <LoginBg ref="loginBg" />
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"
            ><i class="el-icon-picture"></i
            >{{ $t('text.top_nav_background') }}</span
          >
          <TopNavBg ref="topNavBg" />
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"
            ><i class="el-icon-picture"></i>{{ $t('text.menu_bg') }}</span
          >
          <MenuBg ref="menuBg" />
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"
            ><i class="el-icon-picture"></i
            >{{ $t('text.main_content_bg') }}</span
          >
          <MainContentBg ref="mainContentBg" />
        </el-tab-pane>
      </el-tabs>
      <div class="mt-30 text-right">
        <el-button
          class="common-btn"
          :loading="applyLoading"
          :disabled="applyLoading || loading"
          @click="apply()"
          v-if="p('Organisations.Customisation.Add')"
          >{{ $t('text.apply') }}</el-button
        >
        <el-button class="cancel-btn p-10-40" @click="reset()">{{
          $t('text.reset')
        }}</el-button>
      </div>
    </div>
    <ApplyTheme ref="applyTheme" />
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import ApplyTheme from '@/components/manage/admin/customization/ApplyTheme'
import Colors from '@/components/manage/admin/customization/Colors'
import Logo from '@/components/manage/admin/customization/Logo'
import Font from '@/components/manage/admin/customization/Font'
import LoginBg from '@/components/manage/admin/customization/LoginBg'
import TopNavBg from '@/components/manage/admin/customization/TopNavBg'
import MenuBg from '@/components/manage/admin/customization/MenuBg'
import MainContentBg from '@/components/manage/admin/customization/MainContentBg'
import $ from 'jquery'
import swal from 'sweetalert'
export default {
  data() {
    return {
      loading: false,
      applyLoading: false
    }
  },
  components: {
    Colors,
    Logo,
    Font,
    LoginBg,
    TopNavBg,
    MenuBg,
    MainContentBg,
    ApplyTheme
  },
  methods: {
    // apply() {
    //   this.$refs.applyTheme.openDialog()
    // },
    apply() {
      this.applyLoading = true
      ApiService.ApplyTheme({
        OrganisationId: this.$store.getters[`user/selecteOrganisationId`],
        themeValue: JSON.stringify({
          colors: $.extend(
            {},
            this.$store.state.customization.colorObj,
            this.$refs.colors.selectedColorObj
          ),
          font: this.$refs.font.activeFont,
          logo: this.$refs.logo.logo,
          isCircleLogo: this.$refs.logo.isCircleLogo,
          logoPadding: this.$refs.logo.padding,
          loginBg: this.$refs.loginBg.loginBg,
          topNavBg: this.$refs.topNavBg.topNavBg,
          topNavBgOpacity: this.$refs.topNavBg.topNavBgOpacity,
          menuBg: this.$refs.menuBg.menuBg,
          menuBgOpacity: this.$refs.menuBg.menuBgOpacity,
          mainContentBg: this.$refs.mainContentBg.mainContentBg,
          mainContentBgOpacity: this.$refs.mainContentBg.mainContentBgOpacity,
          fontSize: this.$refs.font.fontSizeForm,
          fontColor: this.$refs.font.fontColorForm
        })
      })
        .then(response => {
          this.applyLoading = false
          this.$store.dispatch('customization/getCustomTheme')
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.apply_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.applyLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    reset() {
      this.$refs.colors.selectedColor = 'Default'
      this.$refs.font.activeFont = 'RobotoCondensed'
      this.$refs.logo.logo = ''
      // this.$refs.navigation.selectedLayout = 'default'
      this.$refs.loginBg.loginBg = ''
      this.$refs.topNavBg.topNavBg = ''
      this.$refs.topNavBg.topNavBgOpacity = 0
      this.$refs.menuBg.menuBg = ''
      this.$refs.menuBg.menuBgOpacity = 0.8
      this.$refs.mainContentBg.mainContentBg = ''
      this.$refs.mainContentBg.mainContentBgOpacity = 0.8
      this.$store.dispatch(
        'customization/applyColorForNewDesign',
        this.$refs.colors.selectedColorObj
      )
      this.$store.dispatch(
        'customization/applyFont',
        this.$refs.font.activeFont
      )
      this.$store.commit('customization/SET_LOGO', null)
      this.$store.commit('customization/SET_IS_CIRCLE_LOGO', false)
      this.$store.commit('customization/SET_LOGIN_BG', null)
      this.$store.dispatch('customization/applyTopNavBg', {
        bg: null,
        opacity: 1
      })
      this.$store.dispatch('customization/applyMenuBg', {
        bg: null,
        opacity: 1
      })
      this.$store.dispatch('customization/applyMainContentBg', {
        bg: null,
        opacity: 1
      })
      this.$store.dispatch('customization/applyFontSize', {
        mainTitle: 26,
        title: 18,
        smallTitle: 17,
        bodyText: 16,
        bodyTextSmall: 14,
        supplementaryText: 13
      })
      this.$store.dispatch('customization/applyFontColor', {
        primaryText: '#000000',
        regularText: '#333333',
        secondaryText: '#555555',
        placeholderText: '#c0c4cc'
      })
      this.$message({
        message: this.$t('text.reset_customization_settings'),
        type: 'success'
      })
    }
  }
}
</script>
